import { render, staticRenderFns } from "./CompanyComponent.vue?vue&type=template&id=2a41e5fe&scoped=true&"
import script from "./CompanyComponent.vue?vue&type=script&lang=js&"
export * from "./CompanyComponent.vue?vue&type=script&lang=js&"
import style0 from "./CompanyComponent.vue?vue&type=style&index=0&id=2a41e5fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a41e5fe",
  null
  
)

export default component.exports